import * as React from 'react';

import ActionButton from 'components/buttons/action-button/ActionButton';

import ListDashboardAddListButton from '../ListDashboardAddListButton';

import { updateQueryParams } from 'utils/location';
import { __t, applyTranslations } from 'utils/language';
import { LIST_DASHBOARD_QUERY_PARAMS } from 'utils/list';

import type { LocationWindow } from 'types';

import './list-dashboard-empty-message.scss';

applyTranslations(require('./list-dashboard-empty-message.i18n.json'));

const { PAGE, SEARCH } = LIST_DASHBOARD_QUERY_PARAMS;

type Props = {
  type: 'custom' | 'smart' | 'pagination' | 'search',
  location: LocationWindow,
  onAddList: () => void
};

class ListDashboardEmptyMessage extends React.Component<Props> {
  getJumpToFirstPageButton() {
    const { location } = this.props;
    return (
      <ActionButton
        onClick={() => updateQueryParams(location, { [PAGE]: 1 })}
      >
        {__t('list_dashboard_empty_message.button_return_to_page_one')}
      </ActionButton>
    );
  }

  getResetSearchTextButton() {
    const { location } = this.props;
    return (
      <ActionButton
        onClick={() => updateQueryParams(location, { [SEARCH]: '' })}
      >
        {__t('list_dashboard_empty_message.button_reset_search_text')}
      </ActionButton>
    );
  }

  renderActionButton() {
    const { type, onAddList } = this.props;

    if (type === 'smart') {
      return null;
    }

    if (type === 'custom') {
      return <ListDashboardAddListButton onAddList={onAddList} />;
    }
    if (type === 'pagination') {
      return this.getJumpToFirstPageButton();
    }
    return this.getResetSearchTextButton();
  }

  render() {
    const { type } = this.props;

    return (
      <div className="list-dashboard-empty-message__empty">
        <div className="list-dashboard-empty-message__empty-contents">
          {__t(`list_dashboard_empty_message.results_no_${type}_lists`)}
        </div>
        <div className="list-dashboard-empty-message__empty-contents">
          {this.renderActionButton()}
        </div>
      </div>
    );
  }
}

export default ListDashboardEmptyMessage;
